module.exports = __webpack_public_path__ + "img/quay.8432acb0.jpeg";